<template>
	<div class="eye">
		<svg
			class="eye__inner"
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 40 40"
		>
			<template v-if="open">
				<circle cx="20" cy="20" r="20" fill="#cfd1d2" />
				<circle cx="20" cy="20.552" r="19.448" fill="#e7e8e9" />
				<circle cx="20" cy="21.104" r="18.896" fill="#fff" />
				<circle :cx="cx" :cy="cy" r="4.821" fill="#00204a" />
			</template>
			<template v-else>
				<path
					fill="none"
					stroke="#00204a"
					stroke-linecap="round"
					stroke-miterlimit="10"
					stroke-width="4"
					d="M2 20h36"
				/>
			</template>
		</svg>
	</div>
</template>

<script>
import Tween from '@/plugins/Animator/lib/Tween'
import { easeOutQuad } from '@/lib/easings'
import { toCartesian } from '@/lib/trig'

const CX = 20
const CY = 20
const WINK_SPD = 75
const LOOK_SPD = 250
const LOOK_DISP = 14

export default {
	name: 'Eye',
	data() {
		return {
			x: 0,
			y: 0,
			open: true,
			tween: null,
			winkTimeout: null
		}
	},
	computed: {
		cx() {
			return CX + this.x
		},
		cy() {
			return CY + this.y
		}
	},
	methods: {
		moveTo(vec, { snap = false } = {}) {
			// Remove existing tween
			this.removeTween(this.tween)

			if (snap) {
				// If snapping, move directly
				this.x = vec[0]
				this.y = vec[1]
			} else {
				// Add new movement tween
				const opts = {
					from: [this.x, this.y],
					to: vec,
					ease: easeOutQuad,
					duration: LOOK_SPD,
					type: Tween.TYPE_VEC2
				}
				this.tween = this.addTween(opts, ([x, y]) => {
					this.x = x
					this.y = y
				})
			}
		},
		look(angle, opts) {
			const vec = toCartesian([LOOK_DISP, angle])
			this.moveTo(vec, opts)
		},
		lookAt([x, y], opts) {
			// Calc direction from eye to target
			const { top, left } = this.$el.getBoundingClientRect()
			const angle = Math.atan2(y - top, x - left)
			this.look(angle, opts)
		},
		set(open) {
			this.open = open
		},
		wink() {
			// Only wink if eye is open
			if (this.open) {
				window.clearTimeout(this.winkTimeout)
				this.set(false)
				this.winkTimeout = window.setTimeout(() => (this.open = true), WINK_SPD)
			}
		},
		reset() {
			this.set(true)
			this.moveTo([0, 0])
		}
	},
	beforeDestroy() {
		window.clearTimeout(this.winkTimeout)
	}
}
</script>

<style lang="scss" scoped>
.eye {
	$size: 2.5em;
	position: absolute;
	width: 0;
	height: 0;

	&__inner {
		position: absolute;
		top: 0;
		left: 0;
		transform: translate3d(-50%, -50%, 0);
		width: $size;
		height: $size;
	}
}
</style>
